module.exports = __webpack_public_path__ + "media/images/content/comment-678cb087b05368297f187392679a59b3.png";